module.exports = __webpack_public_path__ + "img/744.4c2747ef.jpg";